import _ from 'lodash';
import React, { PropTypes } from 'react';
import FontAwesome from 'react-fontawesome';
import { DragSource } from 'react-dnd';
import moment from 'moment-timezone';
import 'moment/locale/nb';

const memberSource = {
  // canDrag(props) {
  //   // You can disallow drag based on props
  //   return props.isReady;
  // },
  //
  // isDragging(props, monitor) {
  //   // If your component gets unmounted while dragged
  //   // (like a card in Kanban board dragged between lists)
  //   // you can implement something like this to keep its
  //   // appearance dragged:
  //   return monitor.getItem().id === props.id;
  // },

  beginDrag(props) { // monitor, component
    // Return the data describing the dragged item
    const item = props.member;
    const selectedMembers = props.selectedMembers;
    if (_.size(selectedMembers) > 1) {
      return {items: selectedMembers};
    } else {
      return {items: [item]};
    }
  },
  //
  endDrag(props, monitor) { // component
    if (!monitor.didDrop()) {
      // You can check whether the drop was successful
      // or if the drag ended but nobody handled the drop
      return;
    }
    props.clearSelected();
  //
  //   // When dropped on a compatible target, do something.
  //   // Read the original dragged item from getItem():
  //   const item = monitor.getItem();
  //
  //   // You may also read the drop result from the drop target
  //   // that handled the drop, if it returned an object from
  //   // its drop() method.
  //   const dropResult = monitor.getDropResult();
  //
  //   // This is a good place to call some Flux action
  //   CardActions.moveCardToList(item.id, dropResult.listId);
  }
};

function collect(connect, monitor) {
  return {
    // Call this function inside render()
    // to let React DnD handle the drag events:
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    // You can ask the monitor about the current drag state:
    isDragging: monitor.isDragging()
  };
}

class DragMember extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.showDragHandle = this.showDragHandle.bind(this);
  }

  showDragHandle(selected) {
    let size = _.size(this.props.selectedMembers);
    if (size == 0 || selected) {
      return this.props.connectDragSource(
        <span
          onClick={(e) => {e.preventDefault(); e.stopPropagation();}}
          className="btn btn-default btn-sm pull-right btn-drag">
          <FontAwesome name="bars" />
          {' Dra '}
          {(_.size(this.props.selectedMembers) != 0) &&
            <span className="label label-default">
              {_.size(this.props.selectedMembers)}
            </span>
          }
        </span>
      );
    } else {
      return (
        <span
          onClick={(e) => {e.preventDefault(); e.stopPropagation();}}
          className="btn btn-default btn-sm disabled pull-right">
          {'Ikke valgt'}
        </span>
      );
    }
  }

  render () {
    let selected = (
      _.findIndex(this.props.selectedMembers, {id: this.props.member.id}) != -1
    );
    return this.props.connectDragPreview(
      <label key={this.props.member.id}
        className="list-group-item member-list clearfix"
        htmlFor={'check_' + this.props.member.identifier}>
          <input
            onChange={() => {
              this.props.addToSelected(this.props.member);
            }}
            type="checkbox"
            checked={this.props.selected}
            id={'check_' + this.props.member.identifier}/>
          &emsp;
            <strong className="member-name">
              {this.props.member.member_details.first_name + ' ' +
                this.props.member.member_details.last_name}
            </strong>
          <span className="text-muted">
            {' - '}
            {moment.tz(this.props.member.member_details.birth_date,
              'Europe/Oslo').format("DD.MM.YYYY")}
          </span>
          {this.showDragHandle(selected)}
      </label>
    );
  }
}

DragMember.propTypes = {
  list: PropTypes.array,
  member: PropTypes.object,
  selected: PropTypes.bool,
  selectedMembers: PropTypes.array,
  addToSelected: PropTypes.func,
  clearSelected: PropTypes.func,
  connectDragSource: PropTypes.func,
  connectDragPreview: PropTypes.func,
};

export default DragSource('MEMBER', memberSource, collect)(DragMember);



/** WEBPACK FOOTER **
 ** ./src/containers/events/register/DragMember.js
 **/